import { G23Gains } from '../components/common/constants';

export const getGainId = (gain: string) => {
    if (G23Gains.includes(gain)) {
        return 'Gain_' + gain;
    }
    return gain;
};
